exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body--13ibz {\n  width: 100%;\n  margin-right: 10px;\n}\n\n.wrong-number--zBlko {\n  padding: 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.wrong-number--zBlko .status--1SAGy {\n  color: #1f9bd9;\n  margin-left: 44px;\n  margin-bottom: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"body": "body--13ibz",
	"wrong-number": "wrong-number--zBlko",
	"status": "status--1SAGy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-client/Workflow/Workflow.m.scss
// module id = 1482
// module chunks = 0